import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  content: {
    flexDirection: "column-reverse",
  },
}));
